import angular from 'angular';
import _ from 'lodash';
import Logger from '../../../../../shared/logger';
import { EMPLOYER_WORKFLOW_STATUS } from '../../../../employer/constants/employer-workflow';

export const ConverstionKpiService = (StatsService, $q, $filter) => {
    const getConverstionKpiService = function (startDateThis, previousDate, recruiterId, targets, callback) {
        const requestBody = {
            from: startDateThis,
        };
        if (recruiterId) {
            requestBody.recruiterIds = [recruiterId];
        } else {
            requestBody.allRecruiters = true;
        }

        const interviewedData = [
            {
                conversionType: $filter('translate')('CONVERSION_KPI_INTERVIEWED'),
                count: 0,
            },
            {
                conversionType: $filter('translate')('CONVERSION_KPI_NOT_INTERVIEWED'),
                count: 100,
            },
        ];

        const hiredData = [
            {
                conversionType: $filter('translate')('CONVERSION_KPI_HIRED'),
                count: 0,
            },
            {
                conversionType: $filter('translate')('CONVERSION_KPI_NOT_HIRED'),
                count: 100,
            },
        ];

        const rejectedData = [
            {
                conversionType: $filter('translate')('CONVERSION_KPI_REJECTED'),
                count: 0,
            },
            {
                conversionType: $filter('translate')('CONVERSION_KPI_NOT_REJECTED'),
                count: 100,
            },
        ];

        StatsService.getConversionKpiByTimeFrame(requestBody)
            .then((response) => {
                const conversionProspect = _.find(response.result, { status: 'Prospect' });
                if (conversionProspect && conversionProspect.count > 0) {
                    const interview = _.find(response.result, { status: EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT });
                    if (interview && interview.count > 0) {
                        interviewedData[0].count = interview.count / conversionProspect.count * 100;
                        interviewedData[0].count = interviewedData[0].count.toFixed(0);
                        interviewedData[1].count = 100 - interviewedData[0].count;
                    }

                    const hired = _.find(response.result, { status: 'Hired' });
                    if (hired && hired.count) {
                        hiredData[0].count = hired.count / conversionProspect.count * 100;
                        hiredData[0].count = hiredData[0].count.toFixed(0);
                        hiredData[1].count = 100 - hiredData[0].count;
                    }

                    const rejected = _.find(response.result, { status: 'Rejected' });
                    if (rejected && rejected.count) {
                        rejectedData[0].count = rejected.count / conversionProspect.count * 100;
                        rejectedData[0].count = rejectedData[0].count.toFixed(0);
                        rejectedData[1].count = 100 - rejectedData[0].count;
                    }
                }
                requestBody.from = previousDate.from;
                requestBody.to = previousDate.to;
                StatsService.getConversionKpiByTimeFrame(requestBody)
                    .then((response) => {
                        const previousData = {
                            interviewed: 0.0,
                            hired: 0.0,
                            rejected: 0.0,
                        };

                        const conversionProspect = _.find(response.result, { status: 'Prospect' });
                        if (conversionProspect && conversionProspect.count > 0) {
                            const interview = _.find(response.result, { status: EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT });
                            if (interview && interview.count > 0) {
                                previousData.interviewed = interviewedData[0].count - interview.count / conversionProspect.count * 100;
                                previousData.interviewed = previousData.interviewed.toFixed(2);
                            }

                            const hired = _.find(response.result, { status: 'Hired' });
                            if (hired && hired.count) {
                                previousData.hired = hiredData[0].count - hired.count / conversionProspect.count * 100;
                                previousData.hired = previousData.hired.toFixed(2);
                            }

                            const rejected = _.find(response.result, { status: 'Rejected' });
                            if (rejected && rejected.count) {
                                previousData.rejected = rejectedData[0].count / 100 - rejected.count / conversionProspect.count * 100;
                                previousData.rejected = previousData.rejected.toFixed(2);
                            }
                        }

                        const interviewedOptions = {
                            type: 'doughnut',
                            dataSource: interviewedData,
                            size: {
                                height: 50,
                                width: 50,
                            },
                            innerRadius: 0.75,
                            startAngle: 90,
                            palette: ['#F8C052', '#DADADA'],
                            onPointClick(arg) {
                                arg.target.select();
                            },
                            export: {
                                enabled: false,
                            },
                            series: [{
                                argumentField: 'conversionType',
                                valueField: 'count',
                            }],
                            tooltip: {
                                enabled: true,
                                paddingLeftRight: 12,
                                paddingTopBottom: 10,
                                customizeTooltip(arg) {
                                    return {
                                        text: arg.valueText,
                                    };
                                },
                            },
                        };

                        const hiredOptions = {
                            type: 'doughnut',
                            dataSource: hiredData,
                            size: {
                                height: 50,
                                width: 50,
                            },
                            innerRadius: 0.75,
                            startAngle: 90,
                            palette: ['#4362A4', '#DADADA'],
                            onPointClick(arg) {
                                arg.target.select();
                            },
                            export: {
                                enabled: false,
                            },
                            series: [{
                                argumentField: 'conversionType',
                                valueField: 'count',
                            }],
                            tooltip: {
                                enabled: true,
                                paddingLeftRight: 12,
                                paddingTopBottom: 10,
                                customizeTooltip(arg) {
                                    return {
                                        text: arg.valueText,
                                    };
                                },
                            },
                        };

                        const rejectedOptions = {
                            type: 'doughnut',
                            dataSource: rejectedData,
                            size: {
                                height: 50,
                                width: 50,
                            },
                            innerRadius: 0.75,
                            startAngle: 90,
                            palette: ['#E57D58', '#DADADA'],
                            onPointClick(arg) {
                                arg.target.select();
                            },
                            export: {
                                enabled: false,
                            },
                            series: [{
                                argumentField: 'conversionType',
                                valueField: 'count',
                            }],
                            tooltip: {
                                enabled: true,
                                paddingLeftRight: 12,
                                paddingTopBottom: 10,
                                customizeTooltip(arg) {
                                    return {
                                        text: arg.valueText,
                                    };
                                },
                            },
                        };
                        callback(interviewedOptions, hiredOptions, rejectedOptions, previousData);
                    })
                    .catch(error => Logger.error(error));
            })
            .catch(error => Logger.error(error));
    };

    return {
        getConverstionKpiService,
    };
};

angular
    .module('TALENYA-FE')
    .factory('ConverstionKpiService', ConverstionKpiService);

